module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fontService = require('FontService').default;

var size = fontService.getFontSizes();
var fonts = fontService.getFonts();


    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Checkboxes</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Text</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"selectionText\" name=\"selectionTextColor\" type=\"color\" value=\"")
    ; __append(escapeFn( selectionTextColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"selectionTextColor\" name=\"selectionTextColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( selectionTextColor ))
    ; __append("\" />\r\n\r\n            <select name=\"checkboxFont\" class=\"style-font\"  id=\"checkboxFont\">\r\n               \r\n            </select>\r\n\r\n            <select name=\"checkboxFontSize\" id=\"checkboxFontSize\" class=\"style-font-size\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"checkboxTextBold\" class=\"weightSelectorCheckbox\" name=\"checkboxTextWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( checkboxTextWeightSelection ))
    ; __append("\" />\r\n            <img id=\"checkboxTextItalic\" class=\"styleSelectorCheckbox\" name=\"checkboxTextStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( checkboxTextStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Text (Over)</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"selectionTextOver\" name=\"selectionTextOverColor\" type=\"color\" value=\"")
    ; __append(escapeFn( selectionTextOverColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"selectionTextOverColor\" name=\"selectionTextOverColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( selectionTextOverColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Background</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <div style=\"float:left;padding-right: 5px;\">\r\n                <input id=\"selectionBg\" name=\"selectionBgColor\" type=\"color\" value=\"")
    ; __append(escapeFn( selectionBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n                <input id=\"selectionBgColor\" name=\"selectionBgColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( selectionBgColor ))
    ; __append("\" />\r\n            </div>\r\n            <div>\r\n                <input type=\"checkbox\" id=\"checkBgTransparent\" name=\"checkBgTransparent\" class=\"form-radio-group\" ")
    ; __append(escapeFn( checkBgTransparent ? 'checked' : '' ))
    ; __append("> \r\n                <label class=\"form-group-label\">Transparent</label>\r\n            </div> \r\n       \r\n        </div>\r\n       \r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}